export class CreateAppStatusTimerExtensionRequest {
  applicationStatusTimerId: number;
  createdDateTime: Date;
  id: number;
  timerExtensionDurationInSeconds: number;
}
